import { render, staticRenderFns } from "./ScorePage.vue?vue&type=template&id=7af31151&scoped=true&"
import script from "./ScorePage.vue?vue&type=script&lang=js&"
export * from "./ScorePage.vue?vue&type=script&lang=js&"
import style0 from "./ScorePage.vue?vue&type=style&index=0&id=7af31151&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af31151",
  null
  
)

export default component.exports